import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import * as GoogleAnalytics from '../../lib/google-analytics';

type Props = JSX.IntrinsicAttributes & { children?: React.ReactNode; };

const PagePC = (props:Props) => {
  
  useEffect(() => {
    GoogleAnalytics.customEvent({
      category: 'page_view',
      action: 'page_view_pc',
    });
  }, []);

  return (
    <div {...props}>
      <div className='on-pc-icon'>
        <FontAwesomeIcon icon={faExclamationTriangle} />
      </div>
      <span className='on-pc-status-code'>
        403
      </span>
      <span className='on-pc-status-message'>
        모바일 전용웹 입니다. 모바일로 접속 해주세요.
      </span>
    </div>
  );
};

export default PagePC;